export const onLoad = () => {
	
	if (document.readyState === 'loading') {
	
		// First check that this is the first visit and show loader immediately
		const hasVisited = sessionStorage.getItem('hasVisited');
		if (hasVisited === 'false' || hasVisited == null){
	
			window.document.body.classList.add('loading--site-intro');
	
		}
	
	}

	document.onreadystatechange = function () {

		if (document.readyState === 'interactive') {

			// If this is the first visit
			const hasVisited = sessionStorage.getItem('hasVisited');
			if (hasVisited === 'false' || hasVisited == null){

				// Hide the site loader after timer
				setTimeout(()=>{
					document.body.classList.remove('loading');
					document.body.classList.add('loaded');
					setTimeout(()=>{
						// Switch the site loader style after animation complete
						document.body.classList.add('hiding--site-intro');
					}, 1000);
				}, 2500);

				sessionStorage.setItem('hasVisited', 'true');

			} else {

				document.body.classList.remove('loading');
				document.body.classList.add('loaded','hiding--site-intro');

			}

		}

	}
};
